import React, { useState } from 'react';
import { makeStyles, styled } from '@material-ui/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import { formatCurrency, priceFormat } from '../hooks/currency';
import { getTotalPriceVariant } from '../hooks/price';
import { getOptionPrice, getOptionText } from '../hooks/additions';
import OrderPaymentMethod from './OrderPaymentMethod';
import ClientInfoView from './ClientInfoView';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Collapse from '@mui/material/Collapse';

import {Chip} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({


  table: {
    width: "100%",
    display: 'flex',
    flexDirection: 'column',
    //backgroundColor: 'red'
  },

  divider: {
    margin: theme.spacing(0, 0)
  },

  pageTitle: {
    fontSize: '1.5rem',
    textAlign: 'start',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    textTransform: "uppercase",

    [theme.breakpoints.up('md')]: {
      paddingTop: "10vh",
    },
  },

  price: {
    margin: theme.spacing(0, 0, 0, 2),
    fontSize: "2.0rem",
  },


  delivery: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(0, 4, 0, 4),
  },

  orderType: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: theme.palette.background.grey,
    borderRadius: "0.5rem",
  },


  total: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginRight: theme.spacing(0),
  },


  containerButtons: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    [theme.breakpoints.up('md')]: {
      //bottom: "10vh",
      left: "30%",
      width: "40%",
      padding: theme.spacing(2),
    },
    //backgroundColor:"blue",
  },

  paddiFooter: {
    paddingBottom: "30vh",
    //backgroundColor:"blue",
  },

  cellName: {
    display: 'flex',
    flexDirection: 'column',
  },

  contentOption: {
    display: 'flex',
    flexDirection: 'row',
  },

  listOptions: {
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: 'blue',
  },


  title: {
    width: "100%",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingEnd: theme.spacing(1),
  },


  contentTitle: {
    width: "100%",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },


  payment: {
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    //backgroundColor: 'blue',
  },

  info: {
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

}));



export default function OrderView(props) {

  const classes = useStyles();
  const {
    order,
    orderRt,
    store,
    strings,
  } = props;


  

  const currency = store.currency;
  
  const totalPrice = formatCurrency(currency, order.totalPrice);
  const orderType = order.type;
  const displayType = order.type == "delivery"? strings.order_delivery : strings.order_takeaway
  const deliveryData = order.deliveryPrice;
  const roderNumber = `${strings.ticket_title.toUpperCase()}${orderRt.id}`;
  const displayPaymentMethod = store.payMethods?.find((it)=> it.id == order.payMethod.id); 
  const hasOrderClientInfo = ()=>{
       return order.clientInfo && 
        ( order.clientInfo.name ||
          order.clientInfo.phone ||
            order.clientInfo.message); 
  }

  //console.debug(' displaySummary order', order);

  const [open, setOpen] = useState(false)
  const handleClickMore = () => {
    setOpen(!open);
  };


  const getDisplayVariant = (options) => {
    return options.map((option, index) => (
      <div className={classes.contentOption} key={index}>
        <Typography variant="body2" color="textPrimary">
          {getOptionText(option) + " " + getOptionPrice(currency, option)}
        </Typography>

      </div>
    ))
  }


  const displaySummary = (list) => {
    let display = [];

    for (let i = 0, k = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.variants || item.variants.length == 0) {
        display.push({ ...item });
      } else {

        const itemVariants = item.variants.map((it) => {
          const newItem = { ...item };
          newItem.price = getTotalPriceVariant(item, it.options);
          newItem.count = 1;
          newItem.variants = undefined;
          newItem.displayVariants = getDisplayVariant(it.options);
          return newItem;
        })
        itemVariants.forEach(element => {
          display.push(element);
        });
      }
    }
    //console.debug(' displaySummary', display);
    return display;
  }

  const getLabelNormalDelivery = (delivery, strings) => {
    const distance = delivery.normalRadius.toFixed(1);
    const labelPrice = distance ? `${strings.delivery_fee} ${distance}Km`
      : strings.order_delivery;
    return labelPrice;
  }
  const getLabelExtraDelivery = (delivery, strings) => {
    const extraPrice = delivery.extraPrice ? delivery.extraPrice.toFixed(2) : undefined;
    const labelExtraPrice = extraPrice ?
      `${strings.delivery_extra}  ${delivery.extraByKm}x${delivery.extraDistance.toFixed(1)}Km` : undefined;
    return labelExtraPrice;
  }



  return (

    <TableContainer>
   
      <div  className={classes.contentTitle}>
      <div  className={classes.title}>
        <Typography variant='h5'>{roderNumber}</Typography>
        {open ? 
          <ExpandLess onClick={handleClickMore}/> :
          <ExpandMore onClick={handleClickMore}/>} 
      </div>
      <Typography mr={1} variant='body2'>{store.name.toUpperCase()}</Typography>
      </div>

      

      <Divider className={classes.divider} />


      <Collapse in={open} timeout="auto" unmountOnExit>
      <div className={classes.table}>
        <Table aria-label="simple table" padding='none'>
          <TableBody>
            {
              displaySummary(order.list).map((row, index) => (
                <TableRow key={index} >
                  <TableCell align="left" >{row.count + "x"}</TableCell>
                  <TableCell component="td" scope="row" padding='normal'>
                    <div className={classes.cellName}>
                      <Typography variant="subtitle2" color="textPrimary">{row.name}</Typography>

                      <div className={classes.listOptions}>
                        {row.displayVariants}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="right">{formatCurrency(currency, row.price * row.count, true)}</TableCell>
                </TableRow>
              ))}

         


            {orderType == "delivery" && deliveryData.status != 'disable' &&
              <TableRow>
                <TableCell colSpan={2} padding='none'>
                  <Typography px={0} py={1} variant="body2" color="textPrimary">
                    {getLabelNormalDelivery(deliveryData, strings)}
                  </Typography>
                </TableCell>
                <TableCell align="right" padding='none'>{formatCurrency(currency, deliveryData.normalPrice, true)}</TableCell>
              </TableRow>
            }

            {orderType == "delivery" && deliveryData.status != 'disable' && deliveryData.extraPrice &&
              <TableRow>
                <TableCell colSpan={2} padding='none'>
                  <Typography py={1} variant="body2" color="textPrimary">
                    {getLabelExtraDelivery(deliveryData, strings)}
                  </Typography>
                </TableCell>
                <TableCell align="right" padding='none'>{formatCurrency(currency, deliveryData.extraPrice, true)}</TableCell>
              </TableRow>
            }

          </TableBody>
        </Table>
      </div>
      </Collapse>

      <div className={classes.total}>
        <Typography variant="body1"> {strings.total}: </Typography>
        <p className={classes.price}> {totalPrice}</p>
      </div>

     
      { order.payMethod &&
        <div className={classes.payment}>
           <Divider className={classes.divider} />
          <OrderPaymentMethod
             statusRt = {orderRt.status}
            orderPayMethod={order.payMethod}
            strings={strings}
            currency={currency}
            displayPaymentMethod = {displayPaymentMethod}
          />
        </div>
      }
     

      {  store.clientInfo &&  hasOrderClientInfo() &&
        <div className={classes.info}>
           <Divider className={classes.divider} />
          <ClientInfoView
            clientInfo={order.clientInfo}
            strings={strings}
          />
        </div>
      }

    </TableContainer>

  );
}